import { ClienteStatus } from "../types"

export const STATUS_MAP = {
  draft: { label: "Rascunho", variant: "secondary" },
  pending: { label: "Pendente", variant: "secondary" },
  signed: { label: "Assinado", variant: "default" },
  expired: { label: "Expirado", variant: "destructive" },
  cancelled: { label: "Cancelado", variant: "destructive" },
  ativo: { label: "Ativo", variant: "default" },
  contemplado: { label: "Contemplado", variant: "outline" },
} as const; 